var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UiCalendar, UiButton } from '@claims-ia/design-system';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const qualification = namespace('qualification');
let DateAndTimePicker = class DateAndTimePicker extends Vue {
    get inputValue() {
        return this.value ? this.value.toISOString() : null;
    }
    set inputValue(val) {
        this.$emit('input', val ? new Date(val) : null);
    }
    get minDate() {
        return this.min ? this.min.toISOString() : null;
    }
    get maxDate() {
        return this.max ? this.max.toISOString() : null;
    }
};
__decorate([
    qualification.State('typeTrigram')
], DateAndTimePicker.prototype, "typeTrigram", void 0);
DateAndTimePicker = __decorate([
    Component({
        components: { UiCalendar, UiButton },
        props: {
            value: {
                type: Date,
                default: null,
            },
            max: {
                type: Date,
                default: null,
            },
            min: {
                type: Date,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: 'date',
            },
        },
        model: {
            prop: 'value',
            event: 'input',
        },
    })
], DateAndTimePicker);
export default DateAndTimePicker;
